import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import { mergeFoodLogs } from "../../../../../utils/daily-stats";

const MEAL_ORDER = ["Breakfast", "Lunch", "Dinner", "Snack"];

function getMealKcal(meal) {
  if (meal.kcal != null) return Math.round(meal.kcal);
  return Math.round(
    (meal.proteins || 0) * 4 + (meal.carbs || 0) * 4 + (meal.fats || 0) * 9
  );
}

function sortMeals(meals) {
  return [...meals].sort((a, b) => {
    const indexA = MEAL_ORDER.indexOf(a.name);
    const indexB = MEAL_ORDER.indexOf(b.name);
    return (
      (indexA === -1 ? MEAL_ORDER.length : indexA) -
      (indexB === -1 ? MEAL_ORDER.length : indexB)
    );
  });
}

function LogFoodLogCard({ foodLogs }) {
  const { t } = useTranslation(["athlete-portal", "common"]);
  if (!foodLogs || foodLogs.length === 0) return null;

  const entry = foodLogs[0];
  const hasExternalFoodLog = (entry.foodLog?.meals?.length ?? 0) > 0;
  const hasInternalFoodLog = (entry.internalFoodLog?.meals?.length ?? 0) > 0;

  const source =
    hasExternalFoodLog && hasInternalFoodLog
      ? `${entry.foodLog.source}, ${entry.internalFoodLog.source}`
      : entry.foodLog?.source || entry.internalFoodLog?.source || "";

  const mergedFoodLog = hasInternalFoodLog
    ? mergeFoodLogs(entry.foodLog, entry.internalFoodLog, source)
    : entry.foodLog;

  const meals = (mergedFoodLog?.meals || []).filter(
    (meal) => meal.name || meal.foodName || (meal.foods || []).length > 0
  );
  if (meals.length === 0) return null;

  const orderedMeals = sortMeals(meals);
  const kcalAbbr = t("common:units.kcalAbbr");

  return (
    <div className="log-card log-card--food-log">
      <div className="log-card__header">
        <SvgIcon src="/img/new-icons/restaurant.svg" useCurrentColor={true} />
        {t("calendar.cards.foodLog.title")}
      </div>
      <div className="log-card__body log-card__food-log-body">
        {orderedMeals.map((meal, index) => (
          <div
            className="log-card__food-meal"
            key={`${meal.name || meal.foodName}-${index}`}
          >
            <div className="log-card__food-meal-header">
              <span className="log-card__food-meal-name">
                {meal.name || meal.foodName}
              </span>
              <span className="log-card__food-meal-kcal">
                {getMealKcal(meal)} {kcalAbbr}
              </span>
            </div>
            <ul className="log-card__food-items">
              {(meal.foods || []).map((food, foodIndex) => (
                <li
                  className="log-card__food-item"
                  key={`${food.name}-${foodIndex}`}
                >
                  {food.name}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LogFoodLogCard;
